<template>
    <span >
        <p dir="ltr"
                                                                          style="line-height:1.38;margin-top:12pt;margin-bottom:12pt;"><span
        style="font-size: 13pt; font-family: Arial, sans-serif; background-color: transparent; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline; white-space-collapse: preserve;">{{
            trans("Size charts are available on each product page")
        }}.</span></p><div><br></div></span>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
